import React from 'react';
import { peerBenefits, peerChoices, useCases, useMoments } from '../../data/proposal';
export function ExtensionsPanel() {
  const max = Math.max(...peerChoices.map(c => c.share));
  return <div className="grid gap-12 lg:grid-cols-2" data-id="element-49" data-mp="1sv64titgnz53">
      <section data-id="element-50" data-mp="1sucw4caxyzkb">
        <span className="inline-flex rounded-full border border-dashed border-navy/25 px-3 py-1 text-xs text-navy/55" data-id="element-51" data-mp="1sss875j4uevf">
          Optional future direction
        </span>
        <h2 className="mt-4 text-[32px] font-medium leading-[1.05] tracking-[-0.03em] text-navy" data-id="element-52" data-mp="1jsddjfka3nf9">Peer comparison</h2>
        <p className="mt-4 text-base leading-relaxed text-navy/65" data-id="element-53" data-mp="1oqydddvmc536">
          <span className="text-navy" data-id="element-54" data-mp="19x251ezgrcfy">“What would other fertility specialists do with this patient?”</span> The HCP could compare
          their answer with peers before receiving the product reveal.
        </p>
        <figure className="mt-6 rounded-xl border border-navy/10 bg-paper p-5" data-id="element-55" data-mp="34ab7imtldxop">
          <div className="flex items-baseline justify-between" data-id="element-56" data-mp="397tg2c3p6aw6">
            <p className="text-lg font-medium text-navy" data-id="element-57" data-mp="3hpgbwkkvv1pp">You chose 225 IU</p>
            <p className="text-xs text-navy/40" data-id="element-58" data-mp="3hnd9f12jng43">Illustrative data</p>
          </div>
          <ul className="mt-4 space-y-2" data-id="element-59" data-mp="3cqd6gz0zqth7">
            {peerChoices.map(c => <li key={c.label} className="grid grid-cols-[64px_1fr_36px] items-center gap-3 text-xs" data-id="element-60" data-mp="3rezudp4ootk1">
                <span className={c.you ? 'font-medium text-navy' : 'text-navy/60'} data-id="element-61" data-mp="3mgyax33cis81">{c.label}</span>
                <span className="h-1.5 rounded-full bg-navy/[0.06]" data-id="element-62" data-mp="2yrdoga7zhcu0">
                  <span className={`block h-full rounded-full ${c.you ? 'bg-navy' : 'bg-navy/25'}`} style={{
                width: `${c.share / max * 100}%`
              }} data-id="element-63" data-mp="2tsk90c94zbr7" />
                </span>
                <span className="text-right font-mono tabular-nums text-navy/55" data-id="element-64" data-mp="33q6trfd49xj3">{c.share}%</span>
              </li>)}
          </ul>
        </figure>
        <ul className="mt-4 flex flex-wrap gap-2" data-id="element-65" data-mp="mzhvsfbbz4ar">
          {peerBenefits.map(b => <li key={b} className="rounded-full border border-navy/15 px-3 py-1.5 text-xs text-navy/75" data-id="element-66" data-mp="iz6cb5upfa0v">
              {b}
            </li>)}
        </ul>
      </section>

      <section data-id="element-67" data-mp="3gs848dtu6ion">
        <h2 className="text-[32px] font-medium leading-[1.05] tracking-[-0.03em] text-navy" data-id="element-68" data-mp="3grpwol1q4i1f">One interaction. Many possible moments.</h2>
        <ul className="mt-6 flex flex-wrap gap-2" data-id="element-69" data-mp="3lqj90a59y300">
          {useCases.map(u => <li key={u} className="rounded-full border border-navy/15 bg-white px-4 py-2 text-sm text-navy" data-id="element-70" data-mp="3prv2wrv6lae0">
              {u}
            </li>)}
        </ul>
        <p className="mt-8 text-sm text-navy/45" data-id="element-71" data-mp="2y3kzxxjhhxc4">The same short interaction could work as</p>
        <ul className="mt-2" data-id="element-72" data-mp="323lcfcn0vygj">
          {useMoments.map(m => <li key={m} className="border-t border-navy/10 py-3 text-base text-navy/80" data-id="element-73" data-mp="36uv3mho7z9uj">
              {m}
            </li>)}
        </ul>
      </section>
    </div>;
}